var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5312 20C39.5312 20.6216 39.2843 21.2177 38.8448 21.6573C38.4052 22.0968 37.8091 22.3438 37.1875 22.3438H22.3438V37.1875C22.3438 37.8091 22.0968 38.4052 21.6573 38.8448C21.2177 39.2843 20.6216 39.5312 20 39.5312C19.3784 39.5312 18.7823 39.2843 18.3427 38.8448C17.9032 38.4052 17.6562 37.8091 17.6562 37.1875V22.3438H2.8125C2.1909 22.3438 1.59476 22.0968 1.15522 21.6573C0.71568 21.2177 0.46875 20.6216 0.46875 20C0.46875 19.3784 0.71568 18.7823 1.15522 18.3427C1.59476 17.9032 2.1909 17.6562 2.8125 17.6562H17.6562V2.8125C17.6562 2.1909 17.9032 1.59476 18.3427 1.15522C18.7823 0.71568 19.3784 0.46875 20 0.46875C20.6216 0.46875 21.2177 0.71568 21.6573 1.15522C22.0968 1.59476 22.3438 2.1909 22.3438 2.8125V17.6562H37.1875C37.8091 17.6562 38.4052 17.9032 38.8448 18.3427C39.2843 18.7823 39.5312 19.3784 39.5312 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAdmin);
export default __webpack_public_path__ + "static/media/addAdmin.eadc1e1c13200dc4aca3ca2409515ce4.svg";
export { ForwardRef as ReactComponent };